import { render } from "./CategorySelector.vue?vue&type=template&id=2a778b35&scoped=true"
import script from "./CategorySelector.vue?vue&type=script&lang=js"
export * from "./CategorySelector.vue?vue&type=script&lang=js"

import "./CategorySelector.vue?vue&type=style&index=0&id=2a778b35&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2a778b35"

export default script